import React, { Component } from 'react'
import Head from 'next/head'
import { Header, Footer, PageWrapper } from '../components'
import { withGoogleMap, GoogleMap, Marker } from "react-google-maps"

class ContactPage extends Component {

  render() {
    const { organisation, organisationId, pages } = this.props
    
    let address = "BRHA LIMITED,<br />71-75 Shelton Street,<br /> London,<br /> Greater London,<br /> United Kingdom,<br /> WC2H 9JQ"
    let map = "<iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.9172525019358!2d-0.12573458416354114!3d51.514734079636405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604ccac69823f%3A0x4eb63cbd6bcc52c7!2sShelton%20St%2C%20London%20WC2H%209JQ!5e0!3m2!1sen!2suk!4v1621024202698!5m2!1sen!2suk\" width=\"100%\" height=\"450\" frameBorder=\"0\" style=\"border:0\" allowFullScreen></iframe>"
    //northwest
    if (organisationId == 106) {
      address = "Northwest Rollersports CIC @ Atherton Roller Rink,<br /> Bolton Rd,<br /> Atherton,<br /> Manchester,<br /> M46 9JQ,<br /> United Kingdom"
      map = "<iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1700.4948277019705!2d-2.485169150111975!3d53.52644174770655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487b07f74f60a349%3A0x1dc2feaea0a8464e!2sNorthwest%20Rollersports%20CIC%20%40%20Atherton%20Roller%20Rink!5e0!3m2!1sen!2suk!4v1621022093330!5m2!1sen!2suk\" width=\"100%\" height=\"450\" frameBorder=\"0\" style=\"border:0\" allowFullScreen></iframe>"
    //yorkshire
    } else if (organisationId == 107) {
      address = "Skate Central,<br />1 Queens Rd,<br /> Sheffield, <br /> S2 4DF,<br /> United Kingdom"
      map = "<iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2380.368278454538!2d-1.4652468840970456!3d53.37245977998452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4879829acebc409b%3A0xd10383ec4ae87740!2sSkate%20Central!5e0!3m2!1sen!2suk!4v1621023405374!5m2!1sen!2suk\" width=\"100%\" height=\"450\" frameBorder=\"0\" style=\"border:0\" allowFullScreen></iframe>"
    //southwest
    } else if (organisationId == 108) {
      address = "Kitto Centre,<br />Honicknowle Lane,<br />Plymouth,<br />PL5 3NG"
      map = "<iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2543.0653665344057!2d-4.15603868420249!3d50.40261937946871!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x486c92d75740ab75%3A0xa7a5f6b7cf77f53!2sKitto%20Centre%2C%20Honicknowle%20Ln%2C%20Plymouth%20PL5%203NG!5e0!3m2!1sen!2suk!4v1621023760392!5m2!1sen!2suk\" width=\"100%\" height=\"450\" frameBorder=\"0\" style=\"border:0\" allowFullScreen></iframe>"
    //South
    } else if (organisationId == 36) {
      address = "Bordon Roller Rink,<br />Unit 62,<br />Whitehill &amp; Bordon Enterprise Park, Budds Lane,<br />Bordon,<br />GU35 0FJ"
      let map = "<iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2504.6387137506526!2d-0.8751691841775803!3d51.11512567957258!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4874313e283ac513%3A0x661a6b83414fa1fc!2sBordon+Roller+Rink!5e0!3m2!1sen!2suk!4v1542662397896\" width=\"100%\" height=\"450\" frameBorder=\"0\" style=\"border:0\" allowFullScreen></iframe>"
    //west
    } else if (organisationId == 52) {
      address = "Maurice Chandler Sports and Leisure Centre,<br /> Warrant Rd,<br /> Market Drayton,<br /> TF9 2JP,<br /> United Kingdom"
      map = "<iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2408.5877096597055!2d-2.5311778841153423!3d52.86582907988113!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487a8f4c221d96db%3A0x2fc6b26596f88249!2sMaurice%20Chandler%20Sports%20and%20Leisure%20Centre!5e0!3m2!1sen!2suk!4v1621022270543!5m2!1sen!2suk\" width=\"100%\" height=\"450\" frameBorder=\"0\" style=\"border:0\" allowFullScreen></iframe>"

    }

    return (
      <div className={`u-grid u-grid--contact u-grid-${organisationId}`}>
        <Head>
          <title>{`${organisation.name} | Contact Us`}</title>
        </Head>
        <Header region={organisation.name} regionId={organisation.id} pages={pages}/>
        <div className="u-grid__contact">
          <div className="u-grid__address">
            <div className="c-address" dangerouslySetInnerHTML={{ __html: address }}>
              
            </div>
          </div>
          <div className="u-grid__map" dangerouslySetInnerHTML={{ __html: map }}>
            
          </div>
        </div>
        <Footer regionId={organisation.id}/>
      </div>
    )
  }

}
export default PageWrapper(ContactPage)
